import React, { useEffect, useMemo, useState } from "react";
import useStore from "@/stores/index";
import { useClassroomPolicyStore } from "@/stores/v2/classroomPolicyStore";
import { getClassroomIdForChat, getChatDisabled } from "@/js/utils/chatUtils";
import { ChatButton } from "./ChatButton";
import { ClassroomDetails } from "@/stores/classroomStore_I";

interface Props {
	handleClick: () => void;
	classroom: ClassroomDetails;
}

const ChatToolbarButton = (props: Props): JSX.Element => {
	const [hasUnreadMessages, setHasUnreadMessages] = useState(false);

	const disabledChat = useMemo(() => {
		return getChatDisabled(props.classroom.sourceId);
	}, [props.classroom.sourceId]);

	useEffect(() => {
		const unsubMessageOverview = useStore.subscribe(
			// @ts-expect-error - Leaving code as it is
			(state) => state.chat.unreadMessagesCount,
			(newState) => {
				// @ts-expect-error - Leaving code as it is
				if (newState.data) {
					setHasUnreadMessages(
						// @ts-expect-error - Leaving code as it is
						Object.values(newState.data).some(
							// @ts-expect-error - Leaving code as it is
							(item) => item.hasUnreadMessages && item.classroomId === getClassroomIdForChat(props.classroom)
						)
					);
				}
			}
		);

		return () => {
			unsubMessageOverview();
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	const isChatEnabled = useClassroomPolicyStore.getState().isChatBlocked() === false;
	const isClassroomActive = useStore.getState().classroom.isActiveV2(props.classroom.sourceId);

	return (
		<ChatButton
			isChatActive={isClassroomActive && isChatEnabled}
			hasUnreadMessages={hasUnreadMessages}
			disabledChat={disabledChat}
			{...props}
		/>
	);
};

export default ChatToolbarButton;
